import React, { useState } from 'react';
import { checkedImg } from '../../../assets/images/dashboard-business';
import { TInfo, TStep3Info, TStep4Info, TStep6Info } from '../../../types';
import Button from '../../global/Button';
import BusinessFinalForm from './BusinessFinalForm';
import PartnerFinalForm from './PartnerFinalForm';
import './businessRegistration.css';
import { registerNetcoreActivity } from '../../../utils/registerActivity';
import ReactGA from 'react-ga4';
import { useAppSelector } from '../../../app/hooks';

type Tprops = {
  step1Info: TInfo;
  step3Info: TStep3Info;
  step6Info: TStep6Info[];
  step4Info: TStep4Info;
  partners: TStep4Info[];
  setStep: React.Dispatch<React.SetStateAction<number>>;
  handleSubmit: () => void;
  loading: boolean;
};
const BusinessFinalScreen = ({
  step1Info,
  step3Info,
  step6Info,
  partners,
  step4Info,
  setStep,
  handleSubmit,
  loading,
}: Tprops) => {
  const allPeople = [step4Info].concat(partners);
  const [active, setActive] = useState(0);
  const partnersName = partners.map((partner) => partner.firstName + ' ' + partner.lastName);
  const people = ['BUSINESS DETAILS'].concat(
    [step4Info.firstName + ' ' + step4Info.lastName],
    partnersName,
  );
  const details = useAppSelector((state) => state.auth.loggedInUserDetails);
  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  const milestones = [
    'About business',
    'Business names',
    'Business address',
    'Ownership details',
    'Residential Address',
    'Upload documents',
  ];
  return (
    <div className=''>
      <div>
        <form className='lg:w-[700px] mx-auto'>
          <div className='flex justify-center md:w-full  mx-auto'>
            <div className='w-full stepSeven formCont'>
              <div className='flex mb-[27px] gap-[10px] '>
                {people.map((partner, index) => (
                  <div
                    key={partner}
                    onClick={() => setActive(index)}
                    className={[
                      'bg-[#7683961F] cursor-pointer py-[8px] whitespace-nowrap  space-x-2  flex items-center px-[12px]',
                      index === active && 'border-2 border-[red]-600',
                    ].join(' ')}
                  >
                    <img src={checkedImg} alt='partnerIcon' />
                    <h4 className='whitespace-nowrap'>{partner}</h4>
                  </div>
                ))}
              </div>
              {active === 0 ? (
                <BusinessFinalForm steP3Info={step3Info} step1Info={step1Info} setStep={setStep} />
              ) : (
                <PartnerFinalForm
                  info={allPeople[active - 1]}
                  info6={step6Info[active - 1]}
                  setStep={setStep}
                />
              )}
            </div>
          </div>

          <div>
            <div className=' buttonDiv block justify-between   mx-auto'>
              <div className='flex justify-between  mt-[40px] mb-7 md:mb-0 items-center md:mt-[105px]'>
                <Button
                  className='px-5 !py-[10px] text-[11px] !bg-[#768396] text-white border-[0px] rounded-none '
                  size='sm'
                  underline={false}
                  theme='secondary'
                  onClick={() => {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    setStep((currPage: any) => currPage - 1);
                  }}
                >
                  PREVIOUS
                </Button>
                <Button
                  // disabled={isDisabled}
                  theme='primary'
                  className='px-3 py-[10px] text-[11px] inline-block '
                  size='sm'
                  loading={loading}
                  underline={false}
                  onClick={() => {
                    handleSubmit();
                    registerNetcoreActivity(
                      {
                        emailAddress: details?.email,
                        firstName: details?.firstName,
                        lastName: details?.lastName,
                        mobileNumber: details?.phoneNumber,
                      },
                      'TBH_BUSINESS_REGISTRATION_STEP_9',
                    );
                    registerNetcoreActivity(
                      {
                        emailAddress: details?.email,
                        firstName: details?.firstName,
                        lastName: details?.lastName,
                        mobileNumber: details?.phoneNumber,
                      },
                      'TBH_business_registraton_Incomplete_payment ',
                    );
                    ReactGA.event({
                      category: 'formSubmit',
                      action: 'TBH_BUSINESS_REGISTRATION_STEP_9',
                      label: 'TBH_BUSINESS_REGISTRATION_STEP_9',
                      // value: 1
                    });
                  }}
                >
                  SAVE AND CONTINUE
                </Button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BusinessFinalScreen;
